import { ChangeDetectorRef, Directive, effect, input, InputSignal, output, OutputEmitterRef } from '@angular/core';
import { DataAnalyticsTaggingEvent } from './data-analytics-tagging.domain';
import { DataAnalyticsTaggingService } from './data-analytics-tagging.service';

@Directive({
  selector: '[tdWbDataAnalyticsTagging]'
})
export class DataAnalyticsTaggingDirective {
  analyticsCompleted: OutputEmitterRef<DataAnalyticsTaggingEvent> = output<DataAnalyticsTaggingEvent>();

  dataAnalyticsTaggingEventSignal: InputSignal<DataAnalyticsTaggingEvent> =
    input<DataAnalyticsTaggingEvent>({}, { alias: 'eventSignal' });

  constructor(
    private dataAnalyticsTaggingService: DataAnalyticsTaggingService,
    private changeDetectorRef: ChangeDetectorRef
  ) {
    effect(()=>{
      if (this.dataAnalyticsTaggingEventSignal){
        const event = this.dataAnalyticsTaggingEventSignal();
        if(event && (event.page || event.link || event.search)) {
          if (event.link && event.link.name?.length === 0){
            return;
          }
          this.dataAnalyticsTaggingService.emitTaggingEvent(event);
          this.analyticsCompleted.emit(event);
        }
        this.changeDetectorRef.markForCheck();
      }
    })
  }
}
